import { render, staticRenderFns } from "./examTemplate.vue?vue&type=template&id=cc96f2d2&scoped=true"
import script from "./examTemplate.vue?vue&type=script&lang=js"
export * from "./examTemplate.vue?vue&type=script&lang=js"
import style0 from "./examTemplate.vue?vue&type=style&index=0&id=cc96f2d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc96f2d2",
  null
  
)

export default component.exports